import React, { Fragment } from 'react';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';

import './label.scss';

export interface ILabel extends IComponent {
  href?: string;
  isLive?: boolean;
  isFat?: boolean;
  isCardLabel?: boolean;
  isBlackText?: boolean;
  label: string;
  isInverted?: boolean;
  isWhiteOnRed?: boolean;
  noRounded?: boolean;
  hasBgAlpha?: boolean;
}

const classNames = (
  isLive: boolean,
  isFat = false,
  isCardLabel = false,
  isBlackText = false,
  isInverted = false,
  isWhiteOnRed = false,
  noRounded = false,
  hasBgAlpha = false
) =>
  makeClassNames({
    Label: [
      'label',
      isLive && !isCardLabel && 'label--live',
      isFat && 'label--fat',
      isCardLabel && 'label--card',
      isInverted && 'label--live-inverted',
      isWhiteOnRed && 'label--white-on-red',
      noRounded && 'label--no-rounded',
      hasBgAlpha && 'label--bg-alpha',
    ],
    LabelLink: 'label--link',
    InfoDot: 'label__info-dot',
    LabelText: ['label--text', isCardLabel && 'label__text-card', isBlackText && 'label__text-card--black'],
  });

const Label = ({
  href,
  label,
  /* istanbul ignore next: default value */ isLive = false,
  /* istanbul ignore next: default value */ isFat = false,
  /* istanbul ignore next: default value */ isCardLabel = false,
  /* istanbul ignore next: default value */ isBlackText = false,
  /* istanbul ignore next: default value */ isInverted = false,
  /* istanbul ignore next: default value */ isWhiteOnRed = false,
  /* istanbul ignore next: default value */ noRounded = false,
  /* istanbul ignore next: default value */ hasBgAlpha = false,
}: ILabel) => {
  const cn = classNames(isLive, isFat, isCardLabel, isBlackText, isInverted, isWhiteOnRed, noRounded, hasBgAlpha);

  return (
    <div className={cn.Label}>
      {href ? (
        <a className={cn.LabelLink} href={href}>
          {label}
        </a>
      ) : (
        <Fragment>
          {isCardLabel && isLive && <div className={cn.InfoDot} />}
          <span className={cn.LabelText}>{label}</span>
        </Fragment>
      )}
    </div>
  );
};

export default Label;
